// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────
   EquipmentViewportModal — keystone-accent overrides on GameViewportModal
   ──────────────────────────────────────────
   Overlay / shell / animation geometry lives on the primitive
   (see GameViewportModal.css). This file only owns:
     - The keystone-accent palette overrides for the equipment variant
     - The header strip (.evm-header / .evm-eyebrow / etc.)
     - The body scoping rules that strip full-page chrome from
       PlayerShop / PlayerEquipment / PlayerStats when they render
       inside this modal

   \`--evm-accent-rgb\` is injected as an inline CSS variable on
   \`.gvm-body--equipment\` via the primitive's \`bodyStyle\` prop. Per
   keystone the wrapper sets it to:
     Vancomycin   → 239, 68, 68
     Dupilumab    → 96, 165, 250
     Metformin    → 45, 212, 160
   Falls back to neutral gray when no keystone is equipped. */

.gvm-body--equipment {
  --evm-accent-rgb: 156, 163, 175; /* neutral gray fallback */
  --evm-close-reserve: 56px;
  --evm-header-pad-top: 14px;
  --evm-header-pad-x: 18px;
  --evm-header-pad-bottom: 12px;
  --evm-body-pad-top: 18px;
  --evm-body-pad-x: 22px;
  --evm-body-pad-bottom: 22px;
  --evm-eyebrow-size: 10px;
  --evm-title-size: 13px;
  --evm-subtitle-size: 11px;
  background: rgba(255, 255, 255, 0.045);
  border-color: rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  box-shadow: none;
  backdrop-filter: blur(18px) saturate(1.2);
  -webkit-backdrop-filter: blur(18px) saturate(1.2);
}

/* Gold top hairline — matches keystone-modal-style canonical pattern */
.gvm-body--equipment::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(59, 130, 246, 0.95) 18%,
    rgba(59, 130, 246, 0.95) 82%,
    transparent 100%
  );
  pointer-events: none;
  z-index: 10;
}

.gvm-overlay--equipment {
  padding: 20px;
  background: rgba(0, 0, 0, 0.18);
}

.gvm-overlay--equipment .gvm-close {
  z-index: 8;
  border-radius: 6px;
  border-color: rgba(255, 255, 255, 0.10);
  background: transparent;
  color: rgba(248, 250, 252, 0.55);
}

.gvm-overlay--equipment .gvm-close:hover {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(248, 250, 252, 0.92);
  border-color: rgba(255, 255, 255, 0.22);
}

/* Header strip — gold hairline bottom matching modal top + section dividers */
.evm-header {
  position: relative;
  z-index: 6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--evm-header-pad-top) var(--evm-close-reserve) var(--evm-header-pad-bottom) var(--evm-header-pad-x);
  border-bottom: none;
  flex-shrink: 0;
}

.evm-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(59, 130, 246, 0.3) 18%,
    rgba(59, 130, 246, 0.3) 82%,
    transparent 100%
  );
  pointer-events: none;
}

.evm-header-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

/* Status dot hidden — replaced by pill-badge eyebrow */
.evm-status-dot {
  display: none;
}

/* Eyebrow as PillCard-style type badge (mirrors .pill-card__type--gold) */
.evm-eyebrow {
  font-size: var(--evm-eyebrow-size);
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #fbbf24;
  background: rgba(251, 191, 36, 0.16);
  padding: 2px 8px;
  border-radius: 3px;
}

/* Blue variant — used by /bank/concepts where the eyebrow reads
   "Concept Vault" and the semantic color is blue (matches the
   .pill-card__type--cognitive / blue accent identity for concept-mode
   surfaces). */
.evm-eyebrow--blue {
  color: #60a5fa;
  background: rgba(96, 165, 250, 0.16);
}

.evm-divider {
  display: none;
}

.evm-title {
  font-size: var(--evm-title-size);
  font-weight: 600;
  color: rgba(243, 244, 246, 0.95);
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.evm-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.evm-subtitle {
  font-size: var(--evm-subtitle-size);
  color: rgba(229, 231, 235, 0.55);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.4px;
}

/* Body content area inside the primitive's .gvm-content */
.evm-body {
  padding: var(--evm-body-pad-top) var(--evm-body-pad-x) var(--evm-body-pad-bottom);
}

.evm-body > * {
  max-width: 100%;
}

/* Strip full-page chrome from nested player pages so they render
   inside the modal frame without 100vh / opaque-bg / asymmetric
   padding bleeding through. */
.evm-body .equip-page,
.evm-body .ps-page,
.evm-body .shop-layout,
.evm-body .shop-page {
  padding: 0;
  min-height: 0;
  background: transparent;
}

/* Variant-tinted scrollbar — primitive paints the base geometry, this
   tints the thumb to match the equipped-keystone accent. */
.gvm-content--equipment::-webkit-scrollbar-thumb {
  background: rgba(229, 231, 235, 0.10);
}
.gvm-content--equipment::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--evm-accent-rgb), 0.42);
}

@keyframes evm-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.55; }
}

@media (prefers-reduced-motion: reduce) {
  .evm-status-dot {
    animation: none;
  }
}

@container (max-width: 1800px) {
  .gvm-overlay--equipment {
    padding: clamp(16px, 1.1cqi, 20px);
  }

  .gvm-body--equipment {
    --evm-close-reserve: clamp(48px, 3.2cqi, 56px);
    --evm-header-pad-top: clamp(10px, 0.82cqi, 14px);
    --evm-header-pad-x: clamp(14px, 1.05cqi, 18px);
    --evm-header-pad-bottom: clamp(10px, 0.72cqi, 12px);
    --evm-body-pad-top: clamp(14px, 1.05cqi, 18px);
    --evm-body-pad-x: clamp(16px, 1.35cqi, 22px);
    --evm-body-pad-bottom: clamp(18px, 1.35cqi, 22px);
    --evm-eyebrow-size: clamp(9px, 0.58cqi, 10px);
    --evm-title-size: clamp(12px, 0.76cqi, 13px);
    --evm-subtitle-size: clamp(10px, 0.65cqi, 11px);
  }

  .evm-header-meta {
    gap: clamp(8px, 0.6cqi, 10px);
  }

  .evm-header-actions {
    gap: clamp(8px, 0.7cqi, 12px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EquipmentViewportModal/EquipmentViewportModal.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;6DAiB6D;;AAE7D;EACE,+BAA+B,EAAE,0BAA0B;EAC3D,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;EACtC,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;GAMC;EACD,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gHAAgH;EAChH,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;GAMC;EACD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA,uDAAuD;AACvD;EACE,aAAa;AACf;;AAEA,0EAA0E;AAC1E;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;eAGe;AACf;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D;EACE,iFAAiF;AACnF;;AAEA;EACE,eAAe;AACjB;;AAEA;;8BAE8B;AAC9B;;;;EAIE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;2DAC2D;AAC3D;EACE,qCAAqC;AACvC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,8CAA8C;IAC9C,gDAAgD;IAChD,8CAA8C;IAC9C,mDAAmD;IACnD,8CAA8C;IAC9C,4CAA4C;IAC5C,iDAAiD;IACjD,6CAA6C;IAC7C,4CAA4C;IAC5C,+CAA+C;EACjD;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":["/* ──────────────────────────────────────────\n   EquipmentViewportModal — keystone-accent overrides on GameViewportModal\n   ──────────────────────────────────────────\n   Overlay / shell / animation geometry lives on the primitive\n   (see GameViewportModal.css). This file only owns:\n     - The keystone-accent palette overrides for the equipment variant\n     - The header strip (.evm-header / .evm-eyebrow / etc.)\n     - The body scoping rules that strip full-page chrome from\n       PlayerShop / PlayerEquipment / PlayerStats when they render\n       inside this modal\n\n   `--evm-accent-rgb` is injected as an inline CSS variable on\n   `.gvm-body--equipment` via the primitive's `bodyStyle` prop. Per\n   keystone the wrapper sets it to:\n     Vancomycin   → 239, 68, 68\n     Dupilumab    → 96, 165, 250\n     Metformin    → 45, 212, 160\n   Falls back to neutral gray when no keystone is equipped. */\n\n.gvm-body--equipment {\n  --evm-accent-rgb: 156, 163, 175; /* neutral gray fallback */\n  --evm-close-reserve: 56px;\n  --evm-header-pad-top: 14px;\n  --evm-header-pad-x: 18px;\n  --evm-header-pad-bottom: 12px;\n  --evm-body-pad-top: 18px;\n  --evm-body-pad-x: 22px;\n  --evm-body-pad-bottom: 22px;\n  --evm-eyebrow-size: 10px;\n  --evm-title-size: 13px;\n  --evm-subtitle-size: 11px;\n  background: rgba(255, 255, 255, 0.045);\n  border-color: rgba(255, 255, 255, 0.14);\n  border-radius: 12px;\n  box-shadow: none;\n  backdrop-filter: blur(18px) saturate(1.2);\n  -webkit-backdrop-filter: blur(18px) saturate(1.2);\n}\n\n/* Gold top hairline — matches keystone-modal-style canonical pattern */\n.gvm-body--equipment::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(59, 130, 246, 0.95) 18%,\n    rgba(59, 130, 246, 0.95) 82%,\n    transparent 100%\n  );\n  pointer-events: none;\n  z-index: 10;\n}\n\n.gvm-overlay--equipment {\n  padding: 20px;\n  background: rgba(0, 0, 0, 0.18);\n}\n\n.gvm-overlay--equipment .gvm-close {\n  z-index: 8;\n  border-radius: 6px;\n  border-color: rgba(255, 255, 255, 0.10);\n  background: transparent;\n  color: rgba(248, 250, 252, 0.55);\n}\n\n.gvm-overlay--equipment .gvm-close:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(248, 250, 252, 0.92);\n  border-color: rgba(255, 255, 255, 0.22);\n}\n\n/* Header strip — gold hairline bottom matching modal top + section dividers */\n.evm-header {\n  position: relative;\n  z-index: 6;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--evm-header-pad-top) var(--evm-close-reserve) var(--evm-header-pad-bottom) var(--evm-header-pad-x);\n  border-bottom: none;\n  flex-shrink: 0;\n}\n\n.evm-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(59, 130, 246, 0.3) 18%,\n    rgba(59, 130, 246, 0.3) 82%,\n    transparent 100%\n  );\n  pointer-events: none;\n}\n\n.evm-header-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n/* Status dot hidden — replaced by pill-badge eyebrow */\n.evm-status-dot {\n  display: none;\n}\n\n/* Eyebrow as PillCard-style type badge (mirrors .pill-card__type--gold) */\n.evm-eyebrow {\n  font-size: var(--evm-eyebrow-size);\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #fbbf24;\n  background: rgba(251, 191, 36, 0.16);\n  padding: 2px 8px;\n  border-radius: 3px;\n}\n\n/* Blue variant — used by /bank/concepts where the eyebrow reads\n   \"Concept Vault\" and the semantic color is blue (matches the\n   .pill-card__type--cognitive / blue accent identity for concept-mode\n   surfaces). */\n.evm-eyebrow--blue {\n  color: #60a5fa;\n  background: rgba(96, 165, 250, 0.16);\n}\n\n.evm-divider {\n  display: none;\n}\n\n.evm-title {\n  font-size: var(--evm-title-size);\n  font-weight: 600;\n  color: rgba(243, 244, 246, 0.95);\n  letter-spacing: 0.2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.evm-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.evm-subtitle {\n  font-size: var(--evm-subtitle-size);\n  color: rgba(229, 231, 235, 0.55);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.4px;\n}\n\n/* Body content area inside the primitive's .gvm-content */\n.evm-body {\n  padding: var(--evm-body-pad-top) var(--evm-body-pad-x) var(--evm-body-pad-bottom);\n}\n\n.evm-body > * {\n  max-width: 100%;\n}\n\n/* Strip full-page chrome from nested player pages so they render\n   inside the modal frame without 100vh / opaque-bg / asymmetric\n   padding bleeding through. */\n.evm-body .equip-page,\n.evm-body .ps-page,\n.evm-body .shop-layout,\n.evm-body .shop-page {\n  padding: 0;\n  min-height: 0;\n  background: transparent;\n}\n\n/* Variant-tinted scrollbar — primitive paints the base geometry, this\n   tints the thumb to match the equipped-keystone accent. */\n.gvm-content--equipment::-webkit-scrollbar-thumb {\n  background: rgba(229, 231, 235, 0.10);\n}\n.gvm-content--equipment::-webkit-scrollbar-thumb:hover {\n  background: rgba(var(--evm-accent-rgb), 0.42);\n}\n\n@keyframes evm-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.55; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .evm-status-dot {\n    animation: none;\n  }\n}\n\n@container (max-width: 1800px) {\n  .gvm-overlay--equipment {\n    padding: clamp(16px, 1.1cqi, 20px);\n  }\n\n  .gvm-body--equipment {\n    --evm-close-reserve: clamp(48px, 3.2cqi, 56px);\n    --evm-header-pad-top: clamp(10px, 0.82cqi, 14px);\n    --evm-header-pad-x: clamp(14px, 1.05cqi, 18px);\n    --evm-header-pad-bottom: clamp(10px, 0.72cqi, 12px);\n    --evm-body-pad-top: clamp(14px, 1.05cqi, 18px);\n    --evm-body-pad-x: clamp(16px, 1.35cqi, 22px);\n    --evm-body-pad-bottom: clamp(18px, 1.35cqi, 22px);\n    --evm-eyebrow-size: clamp(9px, 0.58cqi, 10px);\n    --evm-title-size: clamp(12px, 0.76cqi, 13px);\n    --evm-subtitle-size: clamp(10px, 0.65cqi, 11px);\n  }\n\n  .evm-header-meta {\n    gap: clamp(8px, 0.6cqi, 10px);\n  }\n\n  .evm-header-actions {\n    gap: clamp(8px, 0.7cqi, 12px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
